/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import SupremeGolfApiClient from './SupremeGolfApiClient';

const TEE_TIMES_ENDPOINT = 'v6/tee_times';
const TEE_TIME_GROUPS_ENDPOINT = 'v6/tee_time_groups';

class TimeSlotsApi {
  static async getTimeSlots({
    courseId,
    date,
    isRiding,
    maxHour,
    maxPrice,
    minHour,
    minPrice,
    numHoles,
    qty,
    rateTypes,
    isPrepaidOnly,
    includeFeatured = false,
    ...searchParams
  }) {
    const response = await SupremeGolfApiClient.get(
      `${TEE_TIME_GROUPS_ENDPOINT}/at/${courseId}`,
      {
        date,
        isRiding,
        maxHour,
        maxPrice,
        minHour,
        minPrice,
        numHoles,
        qty,
        rateTypes,
        isPrepaidOnly,
        includeFeatured,
        ...searchParams,
      },
    );
    const { data } = response;
    return data;
  }

  static async getTeeTimeProviders({
    courseId,
    date,
    isRiding,
    numHoles,
    qty,
    rateType,
    timeSlot,
    isPrepaidOnly,
    reattempt,
  }, authToken) {
    const payload = {
      authToken,
      date,
      isRiding,
      numHoles,
      qty,
      minorRateType: rateType.minorRateType,
      majorRateType: rateType.majorRateType,
      timeSlot,
      supportsPrepay: true,
      isPrepaidOnly,
    };

    if (reattempt) payload.reattempt = true;
    const response = await SupremeGolfApiClient.get(`${TEE_TIMES_ENDPOINT}/at/${courseId}/tee_times`, payload);
    const { data } = response;
    return data;
  }

  static async getRateTypes({
    courseId,
    date,
    isRiding,
    maxHour,
    maxPrice,
    minHour,
    minPrice,
    numHoles,
    qty,
    rateTypes,
    timeSlot,
    isPrepaidOnly,
    ...searchParams
  }, authToken) {
    const response = await SupremeGolfApiClient.get(
      `${TEE_TIME_GROUPS_ENDPOINT}/at/${courseId}/rate_types`,
      {
        authToken,
        date,
        isRiding,
        maxHour,
        maxPrice,
        minHour,
        minPrice,
        numHoles,
        qty,
        rateTypes,
        timeSlot,
        byMinorRateType: true,
        isPrepaidOnly,
        ...searchParams,
      },
    );
    const { data } = response;
    return data;
  }

  static async prepare({ qty, teeTimeId, prepaymentRuleId }) {
    try {
      const response = await SupremeGolfApiClient.get(
        `${TEE_TIMES_ENDPOINT}/${teeTimeId}/reservations/soft-prepare`,
        { qty, prepaymentRuleId },
      );
      return response.data;
    } catch (error) {
      const {
        response: {
          data: { error: explanatoryError, offerUrl, failureSteps },
        },
      } = error || {};
      return {
        error: explanatoryError || error.message,
        offerUrl,
        statusCode: error.response.status,
        failureSteps,
        teeTimeId,
      };
    }
  }

  static async getRelevantTeeTimes({ courseId, date, teeTimeId }) {
    const payload = { date };
    if (teeTimeId) payload.teeTimeId = teeTimeId;
    const response = await SupremeGolfApiClient.get(`${TEE_TIMES_ENDPOINT}/at/${courseId}/relevant`, payload);

    return response.data;
  }
}

export default TimeSlotsApi;
